import { useLocale } from "../i18n";
import "./loading-skeleton.css";

export type SkeletonVariant = "cards" | "list" | "table" | "form" | "detail" | "calendar" | "workspace" | "inline" | "media" | "tree" | "field";
type Props = { variant?: SkeletonVariant; count?: number; label?: string; className?: string };

/** Retain the shared call-site API; pending reads now use a compact, honest status. */
export function LoadingSkeleton({ variant = "list", label, className = "" }: Props) {
  const { w } = useLocale();
  const message = label || w("جارٍ تحميل المحتوى…", "Loading content…");
  const Tag = variant === "inline" ? "span" : "div";
  return <Tag className={`loading-status ${variant === "inline" ? "loading-status-inline" : ""} ${className}`} data-skeleton={variant} role="status" aria-label={message}>
    <span className="loading-status-indicator" aria-hidden="true" />
    <span className="loading-status-message">{message}</span>
  </Tag>;
}
